/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Task_CompletedInputs */

const cs_event_task_completed = /** @type {(inputs: Event_Task_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úkol dokončen`)
};

const en_event_task_completed = /** @type {(inputs: Event_Task_CompletedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Task completed`)
};

/**
* | output |
* | --- |
* | "Task completed" |
*
* @param {Event_Task_CompletedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const event_task_completed = /** @type {((inputs?: Event_Task_CompletedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Task_CompletedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_event_task_completed(inputs)
	return cs_event_task_completed(inputs)
});